/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber0 = createReactComponent("circle-number-0", "IconCircleNumber0", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", key: "svg-1" }]
]);

export { IconCircleNumber0 as default };
//# sourceMappingURL=IconCircleNumber0.js.map
